import { DOORBELL } from "@volca/ui/components/ui/empty-machine";
import { MachineEmptyState } from "@volca/ui/components/ui/machine-empty-state";
import { ListTableCard } from "@/accounts-payable/common";
import { useGetEmails } from "@/accounts-payable/query";
import { useBusiness } from "@/core/business";
import { ApAddress } from "./ap-address";
import {
  fromCol,
  subjectCol,
  receivedCol,
  invoicesCol,
  statusCol,
} from "./cols";

const columns = [fromCol, subjectCol, receivedCol, invoicesCol, statusCol];

export const ApEmailsTab = ({
  businessId,
  selectedId = null,
  onSelect,
}: {
  businessId: string | null;
  selectedId?: string | null;
  onSelect: (id: string) => void;
}) => {
  const query = useGetEmails(businessId);
  const address = useBusiness().selectedBusiness?.ap_inbound_email;

  return (
    <ListTableCard
      label="Emails"
      query={query}
      columns={columns}
      selectedId={selectedId}
      onSelect={onSelect}
      toolbar={address && <ApAddress address={address} />}
      empty={
        <MachineEmptyState
          art={DOORBELL}
          layout="workspace"
          title="No emails yet"
          description="Invoices emailed to your AP address will show up here."
        />
      }
      error={{
        title: "Couldn’t load emails",
        body: "Please try again in a moment.",
      }}
    />
  );
};
